import React, { useState } from 'react';
import MainLayout from '../Layouts/MainLayout';
import DesignListDetails from './DesignListDetails';

function DesignListDetailsContainer({ isEdit }) {
  return (
    <MainLayout
      navTitle={'Design List Details'}
      navSubTitle={'Welcome to Classy Vouge'}
    >
      <DesignListDetails isEdit={isEdit} />
    </MainLayout>
  );
}

export default DesignListDetailsContainer;
